'use client';

import React from 'react';
import Link from 'next/link';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Home, ArrowLeft, Search, BookOpen, GraduationCap } from 'lucide-react';

const quickLinks = [
  { label: 'Browse Colleges', href: '/', icon: <GraduationCap size={16} /> },
  { label: 'Exam Cutoffs', href: '/exam-cutoff-info', icon: <BookOpen size={16} /> },
  { label: 'College Predictor', href: '/college-predictor', icon: <Search size={16} /> },
];

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="max-w-2xl w-full text-center">
          {/* Visual */}
          <div className="relative inline-flex items-center justify-center mb-8">
            <span className="text-[10rem] font-extrabold leading-none text-primary/10 select-none">404</span>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="bg-primary/10 rounded-2xl p-5">
                <GraduationCap size={52} className="text-primary" />
              </div>
            </div>
          </div>

          <h1 className="text-3xl font-bold text-foreground mb-3">Page Not Found</h1>
          <p className="text-muted-foreground text-lg mb-2">
            Looks like this page took a gap year.
          </p>
          <p className="text-muted-foreground mb-10">
            The page you&apos;re looking for doesn&apos;t exist or has been moved.
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center mb-12">
            <button
              onClick={() => { if (typeof window !== 'undefined') window.history?.back(); }}
              className="inline-flex items-center justify-center gap-2 border border-border bg-background text-foreground px-6 py-3 rounded-xl font-medium hover:bg-accent transition-colors"
            >
              <ArrowLeft size={16} />
              Go Back
            </button>
            <Link
              href="/home"
              className="inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground px-6 py-3 rounded-xl font-medium hover:bg-primary/90 transition-colors"
            >
              <Home size={16} />
              Back to Home
            </Link>
          </div>

          {/* Quick links */}
          <div className="border border-border rounded-2xl p-6 bg-card">
            <p className="text-sm font-semibold text-muted-foreground uppercase tracking-wider mb-4">
              Popular Destinations
            </p>
            <div className="flex flex-wrap gap-3 justify-center">
              {quickLinks?.map((link) => (
                <Link
                  key={link?.href}
                  href={link?.href}
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-primary/10 text-primary text-sm font-medium hover:bg-primary/20 transition-colors"
                >
                  {link?.icon}
                  {link?.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}